import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useCookieConsent } from '@/contexts/CookieConsentContext';

const GOOGLE_ADS_ID = 'AW-18006451750';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

/**
 * Google Ads (gtag.js), laadt pas na toestemming voor marketingcookies.
 */
const GoogleAds = () => {
  const location = useLocation();
  const { marketing } = useCookieConsent();
  const granted = marketing === 'granted';
  const isInitialized = useRef(false);

  useEffect(() => {
    if (!granted || isInitialized.current) return;

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', GOOGLE_ADS_ID);

    isInitialized.current = true;
  }, [granted]);

  useEffect(() => {
    if (isInitialized.current && window.gtag) {
      window.gtag('config', GOOGLE_ADS_ID, { page_path: location.pathname });
    }
  }, [location.pathname]);

  return null;
};

export default GoogleAds;
